import React, {useEffect, useRef, useState} from "react"
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import {useTranslation} from "react-i18next";
import "../../utility/i18n"
import {buttonStyle} from "../../common/constants/buttonStyle";
import {CmCollectionType} from "../types";


interface Props {
    cmCollection?: CmCollectionType,
    children: any,
    maxItemDisplayed?: number,
    showMoreCount?: number,
    itemsList?: any,
    showMoreLabel?: string
    loadableItemClass?: string
}

function CCOLoadableContainer(props: Props) {
    const defaultMaxItemsShown = 3;
    const defaultShowMoreCount = 1;
    const items = props.itemsList ? props.itemsList : props.cmCollection?.items;
    const loadableItemClass = props.loadableItemClass ? '.' + props.loadableItemClass : '';
    const maxItemsShown = props.maxItemDisplayed ?? defaultMaxItemsShown;
    const [itemsShown, setItemsShown] = useState<number>(
        props.maxItemDisplayed ?? defaultMaxItemsShown);

    // collection preview in studio does not work without the effect
    useEffect(() => {
        setItemsShown(props.maxItemDisplayed ?? defaultMaxItemsShown); // aktualisiert sich, wenn die Prop sich ändert
    }, [props.maxItemDisplayed]);

    const showMore = () => {
        if (items && itemsShown < items.length) {
            setItemsShown(prevItemsShown => Math.min(
                prevItemsShown + (props.showMoreCount ?? defaultShowMoreCount), items!.length));
        }
    };

    const containerRef = useRef<HTMLDivElement>(null);

    const showLess = () => {
        if (items && itemsShown > maxItemsShown) {
            setItemsShown(maxItemsShown);
            requestAnimationFrame(() => {
                if (containerRef.current) {
                    const wrapperContainer = containerRef.current.parentElement?.parentElement?.parentElement;
                    const scrollTarget = wrapperContainer?.previousElementSibling ?? wrapperContainer ?? containerRef.current;
                    const rect = scrollTarget.getBoundingClientRect();
                    const scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
                    const scrollOffset = window.scrollY + rect.top - scrollPadding - 20;
                    window.scrollTo({top: Math.max(0, scrollOffset), behavior: 'smooth'});
                }
            });
        }
    };

    const {t} = useTranslation();

    return (
        <Container ref={containerRef} sx={{
            paddingX: '0!important',
            [`div${loadableItemClass}:nth-of-type(n+${itemsShown + 1})`]: {
                display: 'none!important'
            }
        }}>
            {props.children}

            <Box sx={{
                textAlign: 'center'
            }}>
                {(items && items.length > maxItemsShown && itemsShown < items.length) ?
                    <Button variant={"contained"}
                            size={'large'} sx={{
                        ...buttonStyle.green,
                        marginX: 1,
                        marginTop: 12
                    }}
                            onClick={showMore}>{props.showMoreLabel ?? t("coo_show_more")}
                    </Button> : null}
                {(items && itemsShown > maxItemsShown && itemsShown >= items.length) ?
                    <Button variant={"contained"} size={'large'}
                            sx={{...buttonStyle.green, marginX: 1, marginTop: 12}}
                            onClick={showLess}>{t("coo_show_less")}</Button> : null}
            </Box>
        </Container>
    );
}

export default CCOLoadableContainer
